export const VERIFY_CODE_LENGTH = 5
export const VERIFY_CODE_PLACEHOLDER = "_"
